var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".drag_svg__cls-1{fill:#58595b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Interface-Essential_Menu_navigation-menu-vertical",
    "data-name": "Interface-Essential Menu navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_22",
    d: "M2.5 5A2.5 2.5 0 1 0 0 2.5 2.5 2.5 0 0 0 2.5 5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_23",
    d: "M2.5 14A2.5 2.5 0 1 0 0 11.5 2.5 2.5 0 0 0 2.5 14",
    className: "drag_svg__cls-1",
    "data-name": "Oval 23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_24",
    d: "M2.5 23A2.5 2.5 0 1 0 0 20.5 2.5 2.5 0 0 0 2.5 23",
    className: "drag_svg__cls-1",
    "data-name": "Oval 24"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Interface-Essential_Menu_navigation-menu-vertical-2",
    "data-name": "Interface-Essential Menu navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__Group_28-2",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag_svg__navigation-menu-vertical-2",
    "data-name": "navigation-menu-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_22-2",
    d: "M11.5 5A2.5 2.5 0 1 0 9 2.5 2.5 2.5 0 0 0 11.5 5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_23-2",
    d: "M11.5 14A2.5 2.5 0 1 0 9 11.5a2.5 2.5 0 0 0 2.5 2.5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drag_svg__Oval_24-2",
    d: "M11.5 23A2.5 2.5 0 1 0 9 20.5a2.5 2.5 0 0 0 2.5 2.5",
    className: "drag_svg__cls-1",
    "data-name": "Oval 24"
  }))))))));
};
export default SvgDrag;